import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, fmtMoney } from "../lib/api";
import { PageHeader, Surface } from "../components/Primitives";
import { ArrowRight } from "@phosphor-icons/react";

export default function Reserves() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/dashboard/summary").then((r) => setData(r.data)); }, []);

  if (!data) return null;

  return (
    <div>
      <PageHeader overline="Finance" title="Reserves"
        subtitle="Reserve fund balances per aircraft, in your workspace currency. Each aircraft is reconciled individually." />
      <div className="p-8">
        {data.aircraft.length === 0 && <Surface className="p-12 text-center text-zinc-500 text-sm">No aircraft yet.</Surface>}
        <div className="space-y-3">
          {data.aircraft.map((d) => (
            <button key={d.aircraft.id} onClick={() => navigate(`/fleet/${d.aircraft.id}`)}
              data-testid={`reserves-row-${d.aircraft.registration}`}
              className="w-full text-left bg-[#141414] border border-zinc-800 hover:border-amber transition-colors p-5">
              <div className="flex items-center justify-between gap-6 mb-3">
                <div className="flex items-baseline gap-3">
                  <div className="font-mono text-xl text-amber">{d.aircraft.registration}</div>
                  <div className="text-sm text-zinc-300">{d.aircraft.make_model}</div>
                </div>
                <ArrowRight size={16} className="text-zinc-500" />
              </div>
              <div className="grid grid-cols-4 gap-4">
                {["engine_amount", "prop_amount", "maintenance_amount", "improvement_amount"].map((k) => (
                  <div key={k}>
                    <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 font-mono mb-1">{k.replace("_amount", "")}</div>
                    <div className="font-mono text-sm">
                      <span className="text-amber">{fmtMoney(d.reserves[k])}</span>
                      <span className="text-zinc-600"> / {fmtMoney(d.reserve_targets[k])}</span>
                    </div>
                    <div className="h-1 bg-zinc-900 mt-1.5"><div className="h-full bg-amber" style={{ width: `${Math.min(100, d.reserve_pcts[k])}%` }} /></div>
                  </div>
                ))}
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
